/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column prop="bpid" label="ID" width="60">
      </el-table-column>
      <el-table-column prop="name" label="商品名称" width="auto">
      </el-table-column>
      <el-table-column prop="price" label="商品价格" width="100">
      </el-table-column>
      <el-table-column prop="discount_price" label="商品折扣价格" width="120">
      </el-table-column>
      <el-table-column prop="time" label="商品有效天数" width="100">
      </el-table-column>
      <el-table-column prop="commission" label="提成比例" width="100">
      </el-table-column>
      <el-table-column prop="commission1" label="二级提成比例" width="120">
      </el-table-column>
      <el-table-column prop="sort" label="商品排序" width="80">
      </el-table-column>
      <el-table-column prop="yx_time" label="优惠时间" width="140">
      </el-table-column>
      <el-table-column prop="create_time" label="添加时间" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="update_time" label="修改时间" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="140">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="update(scope.row)"><i class="el-icon-edit" />修改</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add>
    <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update>
  </div>
</template>

<script>
import { getshoplist, deleteshoplist, getshoplistedit } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Update from './update.vue'
import Add from './add.vue'
export default {
  // 注册组件
  components: {
    Pagination, Update, Add
  },
  data() {
    return {
      dialog: {
        addDialogStatus: false,
        updateDialogStatus: false
      },
      breadcrumbList: [],
      updateInfo: {},
      loading: false, //是显示加载
      formInline: {
        page: 1
      },
      listData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  created() {
    this.getdata()
    this.generateBreadcrumb()
  },
  watch: {
    $route() {
      this.generateBreadcrumb()
    }
  },
  methods: {
    generateBreadcrumb() {
      // 获取当前路由信息
      const matched = this.$route.matched
      console.log(matched, '++++++++++');
      // 初始化面包屑导航数据
      const breadcrumbList = []
      // 遍历路由信息，生成面包屑导航数据
      matched.forEach(item => {
        const { meta, name, path } = item
        if (meta.requireAuth) {
          breadcrumbList.push({
            name,
            path
          })
        }
      })
      console.log(breadcrumbList, '=========');
      // 保存面包屑导航数据
      this.breadcrumbList = breadcrumbList
      localStorage.setItem('breadcrumbList', JSON.stringify(breadcrumbList))
    },
    //添加
    add() {
      console.log(1111);
      this.dialog.addDialogStatus = true
    },
    //修改
    update(row) {
      console.log(row);
      getshoplistedit({ bpid: row.bpid, type: 'get' }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.dialog.updateDialogStatus = true
          this.updateInfo = res.product
        }
      })
    },
    //删除
    del(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteshoplist({ bpid: row.bpid }).then(res => {
          if (res.code == 200) {
            this.$message({ message: '删除成功', type: 'success' })
            this.getdata()
          } else {
            this.$message({ message: '删除失败', type: 'error' })
          }
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    getdata() {
      this.loading = true
      getshoplist(this.formInline).then(res => {
        if (res.code == 200) {
          this.listData = res.product.data
          this.loading = false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/goods/Goods.vue